module.exports = __webpack_public_path__ + "static/media/Capper-Auto-Group.ebb3d3c8.jpg";